import { EfemGatewayConfigOverridesBodySchema, EfemGatewayConfigVersionConfigResponseSchema, EfemGatewayRegistryTemplateResponseSchema, } from '../../efem-gateway-config-schemas.js';
import { GatewayConfigPushBodySchema, GatewayTypeEfemQuerySchema } from '../../gateway-config-push-api-schemas.js';
import { GatewayConfigPushHistoryResponseSchema, GatewayConfigResendMqttResponseSchema, GatewayConfigVersionParamSchema, GatewaySerialParamSchema, } from '../../gateway-config-push-schemas.js';
import { EfemGatewayConfigPreviewResponseSchema, EfemGatewayConfigPushResponseSchema, EfemGatewayOverridesResponseSchema, LocationGatewayConfigPushResponseSchema, } from '../../schemas.js';
import { EmptyJsonBodySchema } from '../../schemas/location-provider.schemas.js';
import { TenantIdParamSchema } from '../../schemas/params.js';
import { z } from 'zod';
const ProviderGatewayConfigPushResponseSchema = z.union([
    EfemGatewayConfigPushResponseSchema,
    LocationGatewayConfigPushResponseSchema,
]);
/** REST contract for `insight-api/src/routes/provider/gateway-config.routes.ts` (EFEM + unified push). */
export const providerGatewayConfigContract = {
    getConfigPreview: {
        method: 'GET',
        path: '/provider/gateways/:serialNumber/config',
        pathParams: GatewaySerialParamSchema,
        response: EfemGatewayConfigPreviewResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get gateway config preview',
    },
    getRegistryTemplate: {
        method: 'GET',
        path: '/provider/gateways/:serialNumber/config/registry-template',
        pathParams: GatewaySerialParamSchema,
        response: EfemGatewayRegistryTemplateResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get gateway registry template',
    },
    postConfigPreview: {
        method: 'POST',
        path: '/provider/gateways/:serialNumber/config/preview',
        pathParams: GatewaySerialParamSchema,
        body: GatewayConfigPushBodySchema,
        response: EfemGatewayConfigPreviewResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to preview gateway config',
    },
    pushConfig: {
        method: 'POST',
        path: '/provider/gateways/:serialNumber/config/push',
        pathParams: GatewaySerialParamSchema,
        body: GatewayConfigPushBodySchema,
        response: ProviderGatewayConfigPushResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to push gateway config',
    },
    getPushHistory: {
        method: 'GET',
        path: '/provider/gateways/:serialNumber/push-history',
        pathParams: GatewaySerialParamSchema,
        response: GatewayConfigPushHistoryResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get gateway config push history',
    },
    getPushVersionConfig: {
        method: 'GET',
        path: '/provider/gateways/:serialNumber/push/:version/config',
        pathParams: GatewayConfigVersionParamSchema,
        response: EfemGatewayConfigVersionConfigResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get gateway config version snapshot',
    },
    resendMqtt: {
        method: 'POST',
        path: '/provider/gateways/:serialNumber/push/:version/resend-mqtt',
        pathParams: GatewayConfigVersionParamSchema,
        body: EmptyJsonBodySchema,
        response: GatewayConfigResendMqttResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to resend gateway config MQTT',
    },
    getGatewayOverrides: {
        method: 'GET',
        path: '/provider/gateways/:serialNumber/config/overrides',
        pathParams: GatewaySerialParamSchema,
        response: EfemGatewayOverridesResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get gateway config overrides',
    },
    putGatewayOverrides: {
        method: 'PUT',
        path: '/provider/gateways/:serialNumber/config/overrides',
        pathParams: GatewaySerialParamSchema,
        body: EfemGatewayConfigOverridesBodySchema,
        response: EfemGatewayConfigPreviewResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to save gateway config overrides',
    },
    getTenantGatewayOverrides: {
        method: 'GET',
        path: '/provider/tenants/:tenantId/gateway-overrides',
        pathParams: TenantIdParamSchema,
        query: GatewayTypeEfemQuerySchema,
        response: EfemGatewayOverridesResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get tenant gateway config overrides',
    },
    putTenantGatewayOverrides: {
        method: 'PUT',
        path: '/provider/tenants/:tenantId/gateway-overrides',
        pathParams: TenantIdParamSchema,
        query: GatewayTypeEfemQuerySchema,
        body: EfemGatewayConfigOverridesBodySchema,
        response: EfemGatewayOverridesResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to save tenant gateway config overrides',
    },
};
//# sourceMappingURL=provider-gateway-config.contract.js.map